export const firebaseConfig = {
  apiKey: "AIzaSyDdzgDm2SpqQOXuwOtOi_vfq9DumTb0OhE",
  authDomain: "gatormon-8e936.firebaseapp.com",
  projectId: "gatormon-8e936",
  storageBucket: "gatormon-8e936.appspot.com",
  messagingSenderId: "610244893073",
  appId: "1:610244893073:web:fd92a342c002f87309a230",
  measurementId: "G-7ZHEX4Q9CP"
};
